import { render, staticRenderFns } from "./VersaoCadastro.vue?vue&type=template&id=6e6926e0"
import script from "./VersaoCadastro.vue?vue&type=script&lang=js"
export * from "./VersaoCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports